<template>
  <div class="main-gallery-list">
    <!-- <div class="gallery-list-actions">
      <v-btn small tile color="purple"  rounded dark @click="onAdd">
        <v-icon left> mdi-plus </v-icon>
        Добавить изображение
      </v-btn>
    </div> -->
    <div class="gallery-list-container">
      <draggable
        v-model="files"
        handle=".dragHandler"
        ghost-class="ghost"
        class="list-grid-mode"
      >
        <!-- <transition-group> -->
        <div v-for="(file, ind) in files" :key="ind" class="each-item ma-1">
          <div class="gallery-list-item">
            <div class="dragHandler" title="Перетащить">
              <v-img
                :width="200"
                :height="200"
                :src="getSrcFile(file.id)"
                @click="onViewImage(file)"
              ></v-img>
              <div>
                <v-btn
                  x-small
                  :loading="file.loading"
                  :disabled="file.loading"
                  color="red"
                  class="ma-2 white--text"
                  @click="onRemoveItem(ind)"
                >
                  <v-icon small left dark> mdi-delete </v-icon>
                  {{ $t("components.invest.gallery.remove") }}
                </v-btn>
              </div>
            </div>
          </div>
        </div>
        <!-- </transition-group> -->
        <div class="gallery-list-item add-mode">
          <div>
            <v-btn
              class="ma-2"
              outlined
              large
              fab
              color="purple"
              :title="$t('components.invest.gallery.add')"
              @click="onAdd"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>
        </div>
      </draggable>

      <v-dialog
        v-model="view.modal"
        transition="slide-x-reverse-transition"
        mvax-width="800"
        content-class="image_preview"
      >
        <v-layout row wrap modal__block>
          <span class="modal__close" @click="closeViewModal"></span>
          <v-flex xs12 modal__wrapper>
            <h2 class="mb-4" v-if="view.file">{{ view.file.name }}</h2>
            <img v-if="view.file" :src="getSrcFile(view.file.id, false)" />
          </v-flex>
        </v-layout>
      </v-dialog>

      <v-dialog v-model="fileDialog" width="500" persistent>
        <v-layout row wrap modal__block>
          <span class="modal__close" @click="closeModal"></span>
          <v-flex xs12 modal__wrapper>
            <form
              enctype="multipart/form-data"
              novalidate
              v-if="isInitial || isSaving"
            >
              <transition name="slide-fade" mode="in-out">
                <div :class="{ dropbox: true }">
                  <input
                    type="file"
                    multiple
                    accept="image/*"
                    @change="filesChange($event.target.files)"
                    class="input-file"
                  />
                  <p
                    v-if="isInitial"
                    v-html="
                      $t('components.invest.gallery.fileDialog.moveFileHtml')
                    "
                  ></p>
                  <p class="pt-1" v-if="isInitial">
                    <v-icon color="error" class="mr-2">warning</v-icon
                    >{{
                      $t("components.invest.gallery.fileDialog.warningTitle")
                    }}
                    <v-icon color="error" class="ml-2">warning</v-icon>
                    <br />{{
                      $t("components.invest.gallery.fileDialog.warningText")
                    }}
                  </p>
                  <p v-if="isSaving">
                    {{ $t("components.invest.gallery.fileDialog.loading") }}
                  </p>
                </div>
              </transition>
            </form>

            <div v-if="isSuccess">
              <h1>
                {{ $t("components.invest.gallery.fileDialog.loadSuccess") }}
              </h1>
            </div>

            <div v-if="isFailed">
              <h1 class="mb-3">
                {{ $t("components.invest.gallery.fileDialog.errorLoadTitle") }}
              </h1>

              <h3 class="error--text">
                {{ uploadError }}
              </h3>
              <p class="mt-5">
                <a href="javascript:void(0)" @click="reset()">{{
                  $t("components.invest.gallery.fileDialog.again")
                }}</a>
              </p>
            </div>
          </v-flex>
        </v-layout>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { uploadFile } from "@/components/lib/file-upload.service";
import showNotify from "@/services/noty";

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  name: "Gallery",
  components: { draggable },
  model: {
    prop: "items",
    event: "change",
  },
  data: () => ({
    fileDialog: false,
    currentStatus: null,
    uploadError: null,

    view: {
      modal: false,
      file: null,
    },

    files: [],
  }),
  props: {
    items: {
      type: Array,
      default: null,
    },
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
  },

  methods: {
    closeViewModal() {
      this.view.file = null;
      this.view.modal = false;
    },
    onViewImage(file) {
      this.view.file = Object.assign({}, file);
      this.view.modal = true;
    },
    getSrcFile(fileId, thumb = true) {
      let resize = thumb ? "?resize=200,200" : "";
      return `${window.$api_url}v1/files/${fileId}/show-image${resize}`;
    },

    // saveFiles(){
    //     const formData = new FormData();
    //     formData.append("type", 11);
    //     formData.append("public", 1);
    //     formData.append("file", fileList[0]);
    // },

    saveFile(file) {
      let formData = new FormData();
      formData.append("type", 11);
      formData.append("public", 1);
      formData.append("file", file);

      uploadFile(formData)
        .then((response) => {
          if (response && response.data && response.data.result) {
            this.currentStatus = STATUS_SUCCESS;
            if (!this.files) this.files = [];
            this.files.push(response.data.data);
            this.closeModal();
          } else {
            this.currentStatus = STATUS_FAILED;
            this.uploadError = response.data.message;
            showNotify("error", this.uploadError);
          }
        })
        .catch((error) => {
          console.log("CATTTC");
          this.uploadError = error.message;
          this.currentStatus = STATUS_FAILED;
          showNotify("error", error);
        });
    },

    filesChange(fileList) {
      if (!fileList.length) return;
      for (let p = 0; p < fileList.length; p++) this.saveFile(fileList[p]);
    },

    reset() {
      this.currentStatus = STATUS_INITIAL;
      this.uploadError = null;
    },
    closeModal() {
      this.fileDialog = false;
      this.reset();
    },

    onChangeItems() {
      this.$emit("change", this.items);
    },

    onRemoveItem(ind) {
      this.files.splice(ind, 1);
    },
    onAdd() {
      this.fileDialog = true;
    },
  },
  mounted() {
    this.files = this.items;
    this.reset();
  },

  watch: {
    files(val) {
      //  console.log("WWWWWW", val);
      this.$emit("change", val);
    },
    items(val) {
      //this.$set("files", val);
      this.files = val;
      //console.log("items", val);
    },
  },
};
</script>
<style lang="scss">
.main-gallery-list {
  .ghost {
    opacity: 0.3;
  }

  .gallery-list-actions {
    margin-bottom: 10px;
  }
  .gallery-list-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    > div.list-grid-mode {
      display: flex;
      flex-wrap: wrap;
    }

    .gallery-list-item {
      display: flex;
      margin-bottom: 4px;
      cursor: pointer;
      > div {
        padding: 5px;
      }
      .dragHandler {
        background: #f7f7f7;
      }
      &.add-mode {
        button {
          width: 190px !important;
          height: 190px !important;
        }
      }
    }
  }
}
</style>
